import {
  isSpecialCardSet,
  isSupportedCardSet,
} from '@sorare/core/src/lib/cardSets';
import { getSetBackground } from '@sorare/core/src/set';

import commonBaseSetBg from './assets/common-base-set-bg.webp';

type Props = {
  set: Nullable<string>;
};

export const CollectionSetBackground = ({ set }: Props) => {
  if (!isSupportedCardSet(set)) {
    return null;
  }
  if (isSpecialCardSet(set)) {
    return <div style={getSetBackground(set)} />;
  }
  return <img src={commonBaseSetBg} alt={set} />;
};
